module.exports = __webpack_public_path__ + "img/kinumna.7ca863d9.png";